import { render } from "./DualTag.vue?vue&type=template&id=054b1352&scoped=true"
import script from "./DualTag.vue?vue&type=script&lang=js"
export * from "./DualTag.vue?vue&type=script&lang=js"

import "./DualTag.vue?vue&type=style&index=0&id=054b1352&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-054b1352"]])

export default __exports__